import axios from "axios";
import { createSpan } from "../telemetry";
import { withOmicsGetCoalesce } from "../components/chat/omics/omics-get-coalesce";
import { recordOmicsRequest } from "../components/chat/omics/omics-perf";

export const callExternalApi = async (options) => {
  const method = options.config.method?.toUpperCase() || 'GET';
  const url = options.config.url || '';
  const span = createSpan(`API Call: ${method} ${url}`, {
    'http.url': url,
    'http.method': method,
    'component': 'external-api',
  });

  const isOmics = String(url).includes('/api/admin/omics/');
  const runRequest = async () => {
    if (isOmics) {
      recordOmicsRequest(method, url);
    }
    try {
      const response = await axios(options.config);
      const { data } = response;

      span?.setAttributes({
        'http.status_code': response.status,
        'http.response.status_code': response.status,
      });

      if (response.status >= 400) {
        span?.setStatus({ code: 2, message: `HTTP ${response.status}` });
      } else {
        span?.setStatus({ code: 1 }); // OK
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.log('error', error);

      span?.setStatus({ code: 2, message: error.message });
      span?.recordException(error);
      if (axios.isAxiosError(error)) {
        const axiosError = error;

        const { response } = axiosError;

        let message = "http request failed";

        if (response && response.statusText) {
          message = response.statusText;
        }

        if (axiosError.message) {
          message = axiosError.message;
        }

        if (response && typeof response.data === 'string' && response.data) {
          const raw = response.data;
          // Avoid dumping Django/HTML debug pages into UI banners.
          if (/^\s*</.test(raw) || raw.includes('<!DOCTYPE')) {
            const titleMatch = raw.match(/<title[^>]*>([^<]+)<\/title>/i);
            const exceptionMatch = raw.match(/Exception Value:<\/th>\s*<td[^>]*><pre>([^<]+)/i);
            message = exceptionMatch?.[1]?.trim()
              || titleMatch?.[1]?.trim()
              || `HTTP ${response.status || 'error'}`;
          } else {
            message = raw.length > 400 ? `${raw.slice(0, 400)}…` : raw;
          }
        }

        if (response && response.data && response.data.error) {
          message = typeof response.data.error === 'string'
            ? response.data.error
            : JSON.stringify(response.data.error);
        }

        if (response && response.data && response.data.message) {
          message = response.data.message;
        }

        if (response && response.data && response.data.detail) {
          message = typeof response.data.detail === 'string'
            ? response.data.detail
            : JSON.stringify(response.data.detail);
        }

        return {
          data: null,
          error: {
            message,
            status: response?.status,  // Include HTTP status code for retry logic
            data: response?.data,
          },
        };
      }

      return {
        data: null,
        error: {
          message: error.message,
          status: null,
        },
      };
    } finally {
      // Always end the span
      span?.end();
    }
  };

  if (isOmics) {
    return withOmicsGetCoalesce(url, method, runRequest);
  }
  return runRequest();
};
